var React = require('react');

function File (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M58 8H24C21.8783 8 19.8434 8.84285 18.3431 10.3431C16.8429 11.8434 16 13.8783 16 16V80C16 82.1217 16.8429 84.1566 18.3431 85.6569C19.8434 87.1571 21.8783 88 24 88H72C74.1217 88 76.1566 87.1571 77.6569 85.6569C79.1571 84.1566 80 82.1217 80 80V30L58 8Z","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M56 8V32H80","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

File.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = File;

File.default = File;
